import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { DeleteColourApi, UpdateColourApi } from "./Colour.action";
import { setHeading } from "../../../accounts/account.actions";
import { useEffect } from "react";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialFlavors from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewColour = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
  };

  useEffect(() => {
    props.setHeading("Colour List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialFlavors
          title="Flavors List"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: "Name", field: "colourName" },
            { title: "Description", field: "colourDesc" },
            { title: "Created By", field: "userDetails.userName", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/colour?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "portrait";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Colour Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((rowData) => [
                rowData.sequenceNumber,
                rowData.colourName,
                rowData.colourDesc,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Colour Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Edit"),
            isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.UpdateColourApi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteColourApi(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    DeleteColourApi: (tableId) => dispatch(DeleteColourApi(tableId)),
    UpdateColourApi: (newData, oldData) => dispatch(UpdateColourApi(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewColour);